export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    var $hamburger = $('.hamburger');
    $hamburger.on('click', function () {
      if($('.navbar-collapse.collapsing').length == 0) {
          $hamburger.toggleClass('is-active');
          $('html, body').toggleClass('no-scroll full-height');
      }

      if($('.navbar-collapse.show').length == 0) {
        if(window.innerWidth >= 768) {
          $( '.timely-wrapper').removeClass( 'active');
          $( '.timely-wrapper-news').addClass( 'active');
          $('.navbar-nav-submenu .sub-menu').removeClass('active');
          $('.navbar-nav-submenu .timely-1 .sub-menu').addClass('active');

        }
      } else {
        if(window.innerWidth >= 768) {
          $( '.timely-wrapper-news').removeClass( 'active');
          $('.navbar-nav-submenu .timely-1 .sub-menu').removeClass('active');
        }
      }
    });

    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    var cat = urlParams.get('cat');
    var topic = urlParams.get('res-topic');
    console.log(cat);

    if($('body').hasClass('blog')) {
      if(cat != null || topic != null) {
        $('html, body').animate({
          scrollTop: $('.section-filters-categories').offset().top,
        }, 1500);
      }
    }

    if($('body').hasClass('template-resources')){
      if(cat != null || topic != null) {
        $('html, body').animate({
          scrollTop: $('.section-filters-categories').offset().top,
        }, 1500);
      }
    }

    if($('body').hasClass('template-teams')){
      if(cat != null) {
        $('html, body').animate({
          scrollTop: $('.section-filters-categories').offset().top,
        }, 1500);
      }
    }

    $('body').on('click', '.btn-search .ion-md-search', function() {
      $('.wrapper-search-bar').addClass('active-search');
      $('.btn-search .ion-md-search').addClass('ion-md-close');
      $('.btn-search .ion-md-close').removeClass('ion-md-search');
    });

    $('body').on('click', '.btn-search .ion-md-close', function() {
      $('.wrapper-search-bar').removeClass('active-search');
      $('.btn-search .ion-md-close').addClass('ion-md-search');
      $('.btn-search .ion-md-search').removeClass('ion-md-close');
    });

    $('.open-button').click(function (){
      $('.expand-wrap-subtitle').toggleClass('active ');
      $('.expand-wrap-subtitle .open-button .fas').toggleClass('fa-plus fa-times');
    })


    function checkUrl() {
      if (window.location.href.indexOf('page') > -1) {
        return true;
      }
    }



    $('#dropdownList').change(function() {
      var url = new URL(window.location.href);
      const urlParams = url.searchParams;
      urlParams.set('res-topic', $(this).val());
      url.search = urlParams.toString();
      var new_url = url.toString();
      window.location.href = new_url;
    });

    $('#dropdownList').change(function() {
      var url = new URL(window.location.href);
      const urlParams = url.searchParams;
      urlParams.set('res-topic', $(this).val());
      url.search = urlParams.toString();
      var new_url = url.toString();
      window.location.href = new_url;
    });

    $('.wrap-cat-team input[type=radio]').on('change', function() {
      var check = checkUrl();
      var baseUrl = window.location.href.split('/page')[0];
      var val = $(this).val();
      var name = $(this).attr('name');
      if (check == true) {
        window.location.href = baseUrl + '/?' + name + '=' + val;
      } else {
        $(this).closest('form').submit();
      }
    });

    $('.wrap-cat-res input[type=radio]').on('change', function() {
      var check = checkUrl();
      var baseUrl = window.location.href.split('/page')[0];
      var val = $(this).val();
      var name = $(this).attr('name');
      console.log(check);
      if (check == true) {
        window.location.href = baseUrl + '/?' + name + '=' + val;
      } else {
        $(this).closest('form').submit();
      }
    });

    function submenu() {
      if(window.innerWidth >= 768) {

        $('.timely-1 > a').hover(
          function() {
            $( '.timely-wrapper').removeClass( 'active');
            $( '.timely-wrapper-news').addClass( 'active');
            $( '.sub-menu').removeClass( 'active');
           // $( '.timely-1 .sub-menu').addClass( 'active');
            $( '.navbar-nav-submenu .timely-1 .sub-menu').addClass( 'active');
          }
        );


        $('.timely-2 > a').hover(
          function() {
            $( '.timely-wrapper').removeClass( 'active');
            $( '.timely-wrapper-news').addClass( 'active');
            $( '.sub-menu').removeClass( 'active');
            //$( '.timely-2 .sub-menu').addClass( 'active');
            $( '.navbar-nav-submenu .timely-2 .sub-menu').addClass( 'active');
          }
        );



        $('.featured-news > a').hover(
          function() {
            $( '.timely-wrapper').removeClass( 'active');
            $( '.timely-wrapper-featured-news').addClass( 'active');
            $( '.sub-menu').removeClass( 'active');
            //$( '.featured-news .sub-menu').addClass( 'active');
            $( '.navbar-nav-submenu .featured-news .sub-menu').addClass( 'active');
          }
        );

        $('.featured-resource > a').hover(
          function() {
            $( '.timely-wrapper').removeClass( 'active');
            $( '.timely-wrapper-featured-resource').addClass( 'active');
            $( '.sub-menu').removeClass( 'active');
            //$( '.featured-resource .sub-menu').addClass( 'active');
            $( '.navbar-nav-submenu .featured-resource .sub-menu').addClass( 'active');
          }
        );

        $('.upcoming > a').hover(
          function() {
            $( '.timely-wrapper').removeClass( 'active');
            $( '.timely-wrapper-event').addClass( 'active');
            $( '.sub-menu').removeClass( 'active');
            //
            // $( '.upcoming .sub-menu').addClass( 'active');
            $( '.navbar-nav-submenu .upcoming .sub-menu').addClass( 'active');
          }
        );

        $('.timely.menu-item .timely-wrapper-news').remove();
        $('.featured.menu-item .timely-wrapper-featured-news').remove();
        $('.featured.menu-item .timely-wrapper-featured-resource').remove();
        $('.upcoming.menu-item .timely-wrapper-event').remove();

      } else {
        var wrappernews = $( '.timely-wrapper-news').clone();
        $('.timely.menu-item').append(wrappernews);

        var wrapperevent = $( '.timely-wrapper-event').clone();
        $('.upcoming.menu-item').append(wrapperevent);
      }
    }

    submenu();
    $( window ).resize(function() {
      submenu();
    });

    $( document ).ready(function() {

      $('#event-slider').slick({
        slidesToShow: 1,
        dots: true,
        infinite: true,
        prevArrow: '.icon-arrow-up',
        nextArrow: '.icon-arrow-down',
        touchMove: false,
        vertical: true,
        verticalSwiping: true,
        arrows:true,
        asNavFor: '#event-slider-sync',
        // adaptiveHeight: true,
        // initialSlide: 1,
      });

      $('#event-slider-sync').slick({
        slidesToShow: 1,
        asNavFor: '#event-slider',
        infinite: true,
        dots: false,
        verticalSwiping: true,
        touchMove: false,
        vertical: true,
        arrows:false,
      });


      $('.event-carousel-mobile').slick({
        slidesToShow: 1,
        dots: true,
        infinite: true,
        touchMove: true,
        arrows:false,
      });

      $('#slide-top-desc').slick({
        slidesToShow: 1,
        dots: true,
        infinite: true,
        // prevArrow: '.icon-arrow-left-1',
        // nextArrow: '.icon-arrow-right-1',
        touchMove: false,
        //vertical: true,
        //verticalSwiping: true,
        //arrows:true,
        asNavFor: '#slide-top-img',
        // adaptiveHeight: true,
        // initialSlide: 1,
      });

      $('#slide-top-img').slick({
        slidesToShow: 1,
        asNavFor: '#slide-top-desc',
        infinite: true,
        dots: false,
        //verticalSwiping: true,
        touchMove: false,
       // vertical: true,
        arrows:false,
      });


      $('#slide-top-desc .slick-dots').prepend('<li class="wrap-icon-left"><div class="icon-arrow-left"></div></li>');
      $('#slide-top-desc .slick-dots').append('<li class="wrap-icon-right"><div class="icon-arrow-right"></div></li>');

      $('#slide-top-desc .slick-dots .icon-arrow-left').click(function() {
        $('#slide-top-desc').slick('slickPrev');
      })

      $('#slide-top-desc .slick-dots .icon-arrow-right').click(function() {
        $('#slide-top-desc').slick('slickNext');
      })

    });

    // $('.event-item').click(function() {
    //   $('.event-title-current').css({opacity: 0}, {
    //       duration: 200,
    //   }).text($(this).children('.event-name').text()).animate({opacity:1}, {
    //       duration: 200,
    //   })
    //   var indx = Number($(this).attr('data-slick-index'))
    //   $('.event-wrap').hide().animate({opacity:0}, {
    //       duration: 200,
    //   });
    //   $('.event-wrap').eq(indx).show().animate({opacity:1}, {
    //       duration: 200,
    //   })
    // })

    $('.slide-carousel').owlCarousel({
      loop:true,
      nav:false,
      dots:true,
      items:1,
      margin: 0,
      autoHeight: false,
      singleItem: true,
      autoplayHoverPause: true,
      autoplay: false,
      autoplaySpeed: 5000,
      animateOut: 'fadeOut',
      animateIn: 'fadeIn',
    });

    $('.masonry-two-column').masonry({
      // options...
      itemSelector: '.masonry-cell',
      columnWidth: '.grid-sizer',
      percentPosition: true,
      horizontalOrder: true,
      transitionDuration: 0,
      stagger: 0,
    });

    $('.btn-resource').mouseenter(function() {
      $('.overlay-eyes').css({ opacity: 1 });
    }).mouseleave(function() {
      $('.overlay-eyes').css({ opacity: 0 });
    });

    $('.img-wrap-resource').mouseenter(function() {
      $('.overlay-eyes').css({ opacity: 1 });
    }).mouseleave(function() {
      $('.overlay-eyes').css({ opacity: 0 });
    });


    $('.hamburger').on('click', function() {
      $('.what-we-do').mouseover();
      $('#nav-primary li.menu-item .sub-menu').mouseover;
      //$('#nav-primary li.menu-item .sub-menu').css({'pointer-event': 'all', 'z-index': '2','display':'block'});
    });

    $('.selectpicker').selectpicker();

    $('#nav-primary .sub-menu a').on('click', function () {

    })

    // $('#nav-primary > li.menu-item-has-children > a').on('touchstart', function() {
    //   $(this).find('.sub-menu').toggleClass('active');
    // });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js